import { Button, Form, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";

import PromotionForm from "./promotion-form";
import { closeModal } from "store/slices/modalsSlice";
import { createPromotion } from "store/slices/promotionsSlice";
import { buildPromotionPayload } from "./promotion-payload";

const NewPromotionModal = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { isModalOpen, modalType } = useSelector((s) => s.modals);
  const { loading } = useSelector((s) => s.promotions);

  const open = isModalOpen && modalType === "new_promotion";

  const onSubmit = async (values) => {
    try {
      const payload = buildPromotionPayload({ values });

      await dispatch(createPromotion(payload)).unwrap();

      notification.success({ message: "Promotion created" });
      onClose();
    } catch (error) {
      const description =
        typeof error === "string" ? error : "Creation failed";
      notification.error({ message: description });
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title="New Promotion"
      open={open}
      onCancel={onClose}
      width={980}
      destroyOnClose
      bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="new_promotion_form"
          loading={loading}
        >
          Save
        </Button>,
      ]}
    >
      <PromotionForm form={form} onSubmit={onSubmit} formId="new_promotion_form" />
    </Modal>
  );
};

export default NewPromotionModal;
